export default window.AzureStorage.Blob;